import { Box } from "@mui/material";
import { Absentee_Row } from "../../services/attendance/attendance-service";
import { RUDTable } from "../Table/RUDTable";

type Props = { list: Absentee_Row[] };

export default function Absenties_By_Date_List({ list }: Props) {
    async function get_list(...params: any) {
        return Promise.resolve([{ rows: list, count: list.length }, null]);
    }

    return (
        <Box>
            <RUDTable
                storageKey={"absenties-by-date-list"}
                getter={get_list}
                ops={{ read: "" }}
                readables={{ name: "Name" }}
                // defaultSelected={["name"]}
            />
        </Box>
    );
}
